<template>
  <div id="particles-js" class="particle-background"></div>
</template>

<script>
import 'particles.js'

export default {
  name: 'ParticleBackground',
  mounted() {
    // 确保全局变量 particlesJS 可用
    if (window.particlesJS) {
      this.initParticles()
    }
  },
  methods: {
    initParticles() {
      window.particlesJS('particles-js', {
        particles: {
          number: {
            value: 80,           // 减少粒子数量，让效果更像星星
            density: {
              enable: true,
              value_area: 800
            }
          },
          color: {
            value: ["#ffffff", "#00ffff", "#88ffff"]  // 使用白色和青色混合
          },
          shape: {
            type: "circle"
          },
          opacity: {
            value: 0.8,
            random: true,        // 随机透明度
            anim: {
              enable: true,
              speed: 0.5,
              opacity_min: 0.1,
              sync: false
            }
          },
          size: {
            value: 2,           // 减小基础大小
            random: true,       // 随机大小
            anim: {
              enable: true,
              speed: 1,
              size_min: 0.1,
              sync: false
            }
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#00ffff",
            opacity: 0.2,       // 降低连线的透明度
            width: 1
          },
          move: {
            enable: true,
            speed: 0.8,         // 降低移动速度
            direction: "none",
            random: true,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: true,
              rotateX: 600,
              rotateY: 1200
            }
          }
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "grab"      // 鼠标悬停时连接附近的星星
            },
            onclick: {
              enable: true,
              mode: "push"      // 点击时添加新的星星
            },
            resize: true
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 0.4
              }
            },
            push: {
              particles_nb: 3   // 点击时添加的星星数量
            }
          }
        },
        retina_detect: true
      })
    }
  },
  beforeDestroy() {
    // 清理粒子系统
    if (window.pJSDom && window.pJSDom[0]) {
      window.pJSDom[0].pJS.fn.vendors.destroypJS()
      window.pJSDom = []
    }
  }
}
</script>

<style lang="less" scoped>
.particle-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  background: linear-gradient(
    135deg, 
    rgba(0, 15, 30, 0.97) 0%,
    rgba(0, 10, 20, 0.98) 100%
  );

  // 添加星空辉光效果
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 150, 255, 0.15) 0%,
      rgba(0, 0, 30, 0.8) 100%
    );
    pointer-events: none;
  }

  // 添加闪烁的星星
  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(1px 1px at 10% 10%, rgba(255, 255, 255, 0.8) 50%, transparent 100%),
      radial-gradient(1px 1px at 20% 50%, rgba(255, 255, 255, 0.7) 50%, transparent 100%),
      radial-gradient(2px 2px at 30% 30%, rgba(255, 255, 255, 0.6) 50%, transparent 100%),
      radial-gradient(2px 2px at 40% 70%, rgba(255, 255, 255, 0.5) 50%, transparent 100%),
      radial-gradient(1px 1px at 60% 20%, rgba(255, 255, 255, 0.7) 50%, transparent 100%),
      radial-gradient(2px 2px at 70% 90%, rgba(255, 255, 255, 0.6) 50%, transparent 100%),
      radial-gradient(1px 1px at 90% 40%, rgba(255, 255, 255, 0.8) 50%, transparent 100%);
    animation: twinkle 4s infinite alternate;
    pointer-events: none;
  }
}

@keyframes twinkle {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.4;
  }
}

#particles-js {
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    mix-blend-mode: screen;  // 添加混合模式
    filter: drop-shadow(0 0 2px rgba(0, 255, 255, 0.3));
  }
}
</style>
